import { mapState, mapActions } from '@/store/helpers';


import * as TYPES from '../../_store/types';
import { recentListingStatus } from '../../_config';
export default {
    i18next: {
        ns: 'md-listing-list'
    },
    computed: {

        ...mapState({
            "listing": function(store) {
                return this.showLock ? store.listing.slice(0, 2) : store.listing; 
            },
            "totalPage": store => store.totalPage,
            "pageSize": store => store.pageSize,
            "pageNum": store => store.pageNum,
            "listingParams": "listingParams"
        }),
        
        
    },
    inject: ['normalizedFilter'],
    props: {
        showLock: {
            default: false
        }
    },
    methods: {

        ...mapActions({
            "getListing": TYPES.GET_LISTING,
            "setCurrentPage": TYPES.SET_PAGE_NUM,
            "setFetchListingStatus": TYPES.SET_FETCH_LISTING_STATUS
        }),
        
        

        async onPageChange(options) {
            const { page } = options;
            this.setCurrentPage({ data: page });
            this.fetchListingData();
        },
        //  Obtain  recent listing  The data 
        async fetchListingData() {
            this.setFetchStatus(recentListingStatus.loading); //  set state first 
            const params = {
                ... this.normalizedFilter,
                ...this.listingParams
            };
            try {
                await this.getListing({ data: params });
                this.setFetchStatus(recentListingStatus.loaded);
            } catch (err) {
                // TODO  exception handling 
                throw err;
            }
        },
        //  set up recent listing The state the module is in 
        async setFetchStatus(status) {
            this.setFetchListingStatus({ data: status });
        }
    }
};
